import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      // Cancellations short-circuit before this is called.
      retry: (failureCount, error) =>
        error?.response?.status >= 500 && failureCount < 1,
    },
  },
});
